import { FormattedMessage } from 'react-intl'
import Info from 'components/shared/Info'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { usePromotions } from 'components/shared/Promotions/utils/usePromotions'
import useCityBreak from 'components/common/CityBreak/utils/useCityBreak'

const TicketsWithAccommodationDiscountInfo = () => {
    const {
        isBlackPromoForCreatorVisibleOutside,
        isBirthdayPromoForCreatorVisibleOutside,
        isSummerSaleForCreatorVisibleOutside,
    } = usePromotions()
    const { isCityBreakApplicableForTickets } = useCityBreak()

    return (
        <Box mt={[0, 0]} mb={24}>
            <Info
                color="success"
                align={['flex-start', 'center']}
                variantType="tooltip"
            >
                <FormattedMessage
                    id="accommodation.discount_info"
                    defaultMessage="Za pierwszą dobę noclegu otrzymasz 10% zniżki na pierwszy dzień wizyty w parku. Każda kolejna doba pobytu to aż 50% zniżki na kolejny dzień wodnych atrakcji!"
                />
                {isBlackPromoForCreatorVisibleOutside && (
                    <Text variant="bodySmall" color="grayscale_900">
                        <FormattedMessage
                            id="promo.accommodation.discount_black_week_warning"
                            defaultMessage="<span>Uwaga:</span> Promocja nie łączy się z promocją Black Weekend."
                            values={{
                                span: (chunks: string[]) => (
                                    <>
                                        <strong>{chunks}</strong>
                                    </>
                                ),
                            }}
                        />
                    </Text>
                )}
                {isBirthdayPromoForCreatorVisibleOutside && (
                    <Text variant="bodySmall" color="grayscale_900">
                        <FormattedMessage
                            id="promo.accommodation.discount_birthday_promotion"
                            defaultMessage="<span>Uwaga:</span> Promocja nie łączy się z promocją Piąte Urodziny Suntago."
                            values={{
                                span: (chunks: string[]) => (
                                    <>
                                        <strong>{chunks}</strong>
                                    </>
                                ),
                            }}
                        />
                    </Text>
                )}
                {isSummerSaleForCreatorVisibleOutside && (
                    <Text variant="bodySmall" color="grayscale_900">
                        <FormattedMessage
                            id="promo.accommodation.discount_summer_sale_warning"
                            defaultMessage="<span>Uwaga:</span> Promocja nie łączy się z Letnią Wyprzedażą."
                            values={{
                                span: (chunks: string[]) => (
                                    <>
                                        <strong>{chunks}</strong>
                                    </>
                                ),
                            }}
                        />
                    </Text>
                )}
                {isCityBreakApplicableForTickets && (
                    <Text variant="bodySmall" color="grayscale_900">
                        <FormattedMessage
                            id="promo.accommodation.discount_city_break_warning"
                            defaultMessage="_"
                        />
                    </Text>
                )}
            </Info>
        </Box>
    )
}

export default TicketsWithAccommodationDiscountInfo
